module.exports = __webpack_public_path__ + "assets/Retina-Bold.b605391146c083df7e8bba5da23147e2.woff";